var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOntarioIconShareFeedback = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M10 13q.424 0 .713-.287A.97.97 0 0 0 11 12a.97.97 0 0 0-.287-.713A.97.97 0 0 0 10 11a.97.97 0 0 0-.713.287A.97.97 0 0 0 9 12q0 .424.287.713Q9.576 13 10 13M9 9h2V3H9zM0 20V2Q0 1.176.588.588A1.93 1.93 0 0 1 2 0h16q.824 0 1.413.588Q20 1.175 20 2v12q0 .825-.587 1.412A1.93 1.93 0 0 1 18 16H4zm3.15-6H18V2H2v13.125z"
})));
export default SvgOntarioIconShareFeedback;